
import { createCampaign } from "../services/campaignService";
import React, { useState } from "react";
import "./CreateCampaign.css";

const CreateCampaign = () => {
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    location: "",
    date: "",
    organizer: "",
    email: "",
    phone: "",
    volunteers: "",
    description: "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const data = new FormData();

    data.append("title", formData.title);
    data.append("category", formData.category);
    data.append("location", formData.location);
    data.append("date", formData.date);
    data.append("organizer", formData.organizer);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("volunteers", formData.volunteers);
    data.append("description", formData.description);

    if (formData.image) {
      data.append("image", formData.image);
    }

  const response = await createCampaign(data);

alert(response.message);
    setFormData({
      title: "",
      category: "",
      location: "",
      date: "",
      organizer: "",
      email: "",
      phone: "",
      volunteers: "",
      description: "",
      image: null,
    });

  } catch (error) {
  console.log(error);

  alert(error.message || "Failed to submit campaign.");
}
};

  return (
    <div className="create-campaign-page">
      <div className="form-container">
        <h1>Create Campaign</h1>
        <p>
          Fill out the form below to submit your environmental campaign for
          admin review.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="title"
            placeholder="Campaign Title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>
            <option>Tree Plantation</option>
            <option>Avoid Plastic</option>
            <option>Cleanliness Drive</option>
            <option>Water Conservation</option>
            <option>Environmental Awareness</option>
          </select>

          <input
            type="text"
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleChange}
            required
          />

          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="organizer"
            placeholder="Organizer Name"
            value={formData.organizer}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Contact Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <input
            type="number"
            name="volunteers"
            placeholder="Expected Volunteers"
            value={formData.volunteers}
            onChange={handleChange}
          />

          <textarea
            name="description"
            rows="6"
            placeholder="Campaign Description"
            value={formData.description}
            onChange={handleChange}
            required
          />

          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />

          <button type="submit" className="submit-btn">
            Submit Campaign
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCampaign;